import { Route, Routes } from 'react-router-dom';

import AppContent from '@sayyesschool/frontend/components/app-content';
import AppHeader from '@sayyesschool/frontend/components/app-header';
import AppNav from '@sayyesschool/frontend/components/app-nav';
import AppShell from '@sayyesschool/frontend/components/app-shell';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import { useUser } from '@sayyesschool/frontend/features/user';

import routes from './routes';

import styles from './App.module.scss';

export default function App() {
    const [user] = useUser();

    if (!user) return <LoadingIndicator fullscreen />;

    return (
        <AppShell className={styles.root}>
            <AppHeader user={user}>
                <AppNav
                    items={routes.map(route => ({
                        key: route.path,
                        content: route.title,
                        icon: route.icon,
                        path: route.path
                    }))}
                    orientation="horizontal"
                />
            </AppHeader>

            <AppContent>
                <Routes>
                    {routes.map(({ path, component: Component, ...rest }) =>
                        <Route
                            key={path}
                            element={<Component />}
                            path={path === '/' ? '/' : path + '/*'}
                            {...rest}
                        />
                    )}
                </Routes>
            </AppContent>
        </AppShell>
    );
}